// extracted by mini-css-extract-plugin
export default {"navItem":"SidebarLink_navItem__ClLuq","navLink":"SidebarLink_navLink__E8IWA","activeClassName":"SidebarLink_activeClassName__llGhV"};